import { render, staticRenderFns } from "./EquipmentsView.vue?vue&type=template&id=2d8a7a6c&scoped=true&"
import script from "./EquipmentsView.vue?vue&type=script&lang=js&"
export * from "./EquipmentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8a7a6c",
  null
  
)

export default component.exports